// app/composables/pages/pagination.ts

import type { Ref } from "@vue/reactivity";
import { useRouteQuery } from "~/composables/routeQuery";

interface UsePagination {
  currentPage: Ref<number>;
  itemsPerPage: number;
  pageCount: number;
  resetPage: () => void;
}

// MEMORY LEAK FIX (2025-12-31):
// - Moved useRouteQuery() to setup level
export const usePagination = (): UsePagination => {
  const route = useRoute();
  // MEMORY LEAK FIX: Get composable at setup level
  const { deleteQuery } = useRouteQuery();

  const pageCount = 3; // Amount of visible pages
  const itemsPerPage = 10;

  const routePage = route.query.page;
  const initialPage = routePage ? parseInt(routePage.toString(), 10) || 1 : 1;

  const currentPage = ref<number>(initialPage);

  // MEMORY LEAK FIX: Uses deleteQuery from setup level
  function resetPage(): void {
    currentPage.value = 1;
    deleteQuery("page");
  }

  return {
    currentPage,
    pageCount,
    itemsPerPage,
    resetPage,
  };
};
